/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RecoverPasswordRouteImport } from './routes/recover-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutUsersettingsRouteImport } from './routes/_layout/usersettings'
import { Route as LayoutUsersRouteImport } from './routes/_layout/users'
import { Route as LayoutTagsRouteImport } from './routes/_layout/tags'
import { Route as LayoutRolesRouteImport } from './routes/_layout/roles'
import { Route as LayoutPublicationsRouteImport } from './routes/_layout/publications'
import { Route as LayoutPermissionsRouteImport } from './routes/_layout/permissions'
import { Route as LayoutMediaRouteImport } from './routes/_layout/media'
import { Route as LayoutCategoriesRouteImport } from './routes/_layout/categories'
import { Route as LayoutAuthorsRouteImport } from './routes/_layout/authors'
import { Route as LayoutAuthorgroupsRouteImport } from './routes/_layout/authorgroups'
import { Route as LayoutAdsRouteImport } from './routes/_layout/ads'
import { Route as LayoutSettingsIndexRouteImport } from './routes/_layout/settings/index'
import { Route as LayoutFormsIndexRouteImport } from './routes/_layout/forms/index'
import { Route as LayoutSettingsSubscriptionsRouteImport } from './routes/_layout/settings/subscriptions'
import { Route as LayoutSettingsRatechartsRouteImport } from './routes/_layout/settings/ratecharts'
import { Route as LayoutSettingsPriocategoriesRouteImport } from './routes/_layout/settings/priocategories'
import { Route as LayoutSettingsNavigationRouteImport } from './routes/_layout/settings/navigation'
import { Route as LayoutSettingsMimetypesRouteImport } from './routes/_layout/settings/mimetypes'
import { Route as LayoutSettingsLandingpageRouteImport } from './routes/_layout/settings/landingpage'
import { Route as LayoutSettingsActionsRouteImport } from './routes/_layout/settings/actions'
import { Route as LayoutFormsSubscriptionsRouteImport } from './routes/_layout/forms/subscriptions'
import { Route as LayoutFormsNewslettersRouteImport } from './routes/_layout/forms/newsletters'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUsersettingsRoute = LayoutUsersettingsRouteImport.update({
  id: '/usersettings',
  path: '/usersettings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUsersRoute = LayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTagsRoute = LayoutTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRolesRoute = LayoutRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPublicationsRoute = LayoutPublicationsRouteImport.update({
  id: '/publications',
  path: '/publications',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPermissionsRoute = LayoutPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMediaRoute = LayoutMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCategoriesRoute = LayoutCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAuthorsRoute = LayoutAuthorsRouteImport.update({
  id: '/authors',
  path: '/authors',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAuthorgroupsRoute = LayoutAuthorgroupsRouteImport.update({
  id: '/authorgroups',
  path: '/authorgroups',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdsRoute = LayoutAdsRouteImport.update({
  id: '/ads',
  path: '/ads',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsIndexRoute = LayoutSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutFormsIndexRoute = LayoutFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsSubscriptionsRoute =
  LayoutSettingsSubscriptionsRouteImport.update({
    id: '/settings/subscriptions',
    path: '/settings/subscriptions',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsRatechartsRoute =
  LayoutSettingsRatechartsRouteImport.update({
    id: '/settings/ratecharts',
    path: '/settings/ratecharts',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsPriocategoriesRoute =
  LayoutSettingsPriocategoriesRouteImport.update({
    id: '/settings/priocategories',
    path: '/settings/priocategories',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsNavigationRoute =
  LayoutSettingsNavigationRouteImport.update({
    id: '/settings/navigation',
    path: '/settings/navigation',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsMimetypesRoute = LayoutSettingsMimetypesRouteImport.update({
  id: '/settings/mimetypes',
  path: '/settings/mimetypes',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsLandingpageRoute =
  LayoutSettingsLandingpageRouteImport.update({
    id: '/settings/landingpage',
    path: '/settings/landingpage',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsActionsRoute = LayoutSettingsActionsRouteImport.update({
  id: '/settings/actions',
  path: '/settings/actions',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutFormsSubscriptionsRoute =
  LayoutFormsSubscriptionsRouteImport.update({
    id: '/forms/subscriptions',
    path: '/forms/subscriptions',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutFormsNewslettersRoute = LayoutFormsNewslettersRouteImport.update({
  id: '/forms/newsletters',
  path: '/forms/newsletters',
  getParentRoute: () => LayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/ads': typeof LayoutAdsRoute
  '/authorgroups': typeof LayoutAuthorgroupsRoute
  '/authors': typeof LayoutAuthorsRoute
  '/categories': typeof LayoutCategoriesRoute
  '/media': typeof LayoutMediaRoute
  '/permissions': typeof LayoutPermissionsRoute
  '/publications': typeof LayoutPublicationsRoute
  '/roles': typeof LayoutRolesRoute
  '/tags': typeof LayoutTagsRoute
  '/users': typeof LayoutUsersRoute
  '/usersettings': typeof LayoutUsersettingsRoute
  '/': typeof LayoutIndexRoute
  '/forms/newsletters': typeof LayoutFormsNewslettersRoute
  '/forms/subscriptions': typeof LayoutFormsSubscriptionsRoute
  '/settings/actions': typeof LayoutSettingsActionsRoute
  '/settings/landingpage': typeof LayoutSettingsLandingpageRoute
  '/settings/mimetypes': typeof LayoutSettingsMimetypesRoute
  '/settings/navigation': typeof LayoutSettingsNavigationRoute
  '/settings/priocategories': typeof LayoutSettingsPriocategoriesRoute
  '/settings/ratecharts': typeof LayoutSettingsRatechartsRoute
  '/settings/subscriptions': typeof LayoutSettingsSubscriptionsRoute
  '/forms': typeof LayoutFormsIndexRoute
  '/settings': typeof LayoutSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/ads': typeof LayoutAdsRoute
  '/authorgroups': typeof LayoutAuthorgroupsRoute
  '/authors': typeof LayoutAuthorsRoute
  '/categories': typeof LayoutCategoriesRoute
  '/media': typeof LayoutMediaRoute
  '/permissions': typeof LayoutPermissionsRoute
  '/publications': typeof LayoutPublicationsRoute
  '/roles': typeof LayoutRolesRoute
  '/tags': typeof LayoutTagsRoute
  '/users': typeof LayoutUsersRoute
  '/usersettings': typeof LayoutUsersettingsRoute
  '/': typeof LayoutIndexRoute
  '/forms/newsletters': typeof LayoutFormsNewslettersRoute
  '/forms/subscriptions': typeof LayoutFormsSubscriptionsRoute
  '/settings/actions': typeof LayoutSettingsActionsRoute
  '/settings/landingpage': typeof LayoutSettingsLandingpageRoute
  '/settings/mimetypes': typeof LayoutSettingsMimetypesRoute
  '/settings/navigation': typeof LayoutSettingsNavigationRoute
  '/settings/priocategories': typeof LayoutSettingsPriocategoriesRoute
  '/settings/ratecharts': typeof LayoutSettingsRatechartsRoute
  '/settings/subscriptions': typeof LayoutSettingsSubscriptionsRoute
  '/forms': typeof LayoutFormsIndexRoute
  '/settings': typeof LayoutSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_layout/ads': typeof LayoutAdsRoute
  '/_layout/authorgroups': typeof LayoutAuthorgroupsRoute
  '/_layout/authors': typeof LayoutAuthorsRoute
  '/_layout/categories': typeof LayoutCategoriesRoute
  '/_layout/media': typeof LayoutMediaRoute
  '/_layout/permissions': typeof LayoutPermissionsRoute
  '/_layout/publications': typeof LayoutPublicationsRoute
  '/_layout/roles': typeof LayoutRolesRoute
  '/_layout/tags': typeof LayoutTagsRoute
  '/_layout/users': typeof LayoutUsersRoute
  '/_layout/usersettings': typeof LayoutUsersettingsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/forms/newsletters': typeof LayoutFormsNewslettersRoute
  '/_layout/forms/subscriptions': typeof LayoutFormsSubscriptionsRoute
  '/_layout/settings/actions': typeof LayoutSettingsActionsRoute
  '/_layout/settings/landingpage': typeof LayoutSettingsLandingpageRoute
  '/_layout/settings/mimetypes': typeof LayoutSettingsMimetypesRoute
  '/_layout/settings/navigation': typeof LayoutSettingsNavigationRoute
  '/_layout/settings/priocategories': typeof LayoutSettingsPriocategoriesRoute
  '/_layout/settings/ratecharts': typeof LayoutSettingsRatechartsRoute
  '/_layout/settings/subscriptions': typeof LayoutSettingsSubscriptionsRoute
  '/_layout/forms/': typeof LayoutFormsIndexRoute
  '/_layout/settings/': typeof LayoutSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/datenschutz'
    | '/impressum'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/ads'
    | '/authorgroups'
    | '/authors'
    | '/categories'
    | '/media'
    | '/permissions'
    | '/publications'
    | '/roles'
    | '/tags'
    | '/users'
    | '/usersettings'
    | '/'
    | '/forms/newsletters'
    | '/forms/subscriptions'
    | '/settings/actions'
    | '/settings/landingpage'
    | '/settings/mimetypes'
    | '/settings/navigation'
    | '/settings/priocategories'
    | '/settings/ratecharts'
    | '/settings/subscriptions'
    | '/forms'
    | '/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/datenschutz'
    | '/impressum'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/ads'
    | '/authorgroups'
    | '/authors'
    | '/categories'
    | '/media'
    | '/permissions'
    | '/publications'
    | '/roles'
    | '/tags'
    | '/users'
    | '/usersettings'
    | '/'
    | '/forms/newsletters'
    | '/forms/subscriptions'
    | '/settings/actions'
    | '/settings/landingpage'
    | '/settings/mimetypes'
    | '/settings/navigation'
    | '/settings/priocategories'
    | '/settings/ratecharts'
    | '/settings/subscriptions'
    | '/forms'
    | '/settings'
  id:
    | '__root__'
    | '/_layout'
    | '/datenschutz'
    | '/impressum'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/_layout/ads'
    | '/_layout/authorgroups'
    | '/_layout/authors'
    | '/_layout/categories'
    | '/_layout/media'
    | '/_layout/permissions'
    | '/_layout/publications'
    | '/_layout/roles'
    | '/_layout/tags'
    | '/_layout/users'
    | '/_layout/usersettings'
    | '/_layout/'
    | '/_layout/forms/newsletters'
    | '/_layout/forms/subscriptions'
    | '/_layout/settings/actions'
    | '/_layout/settings/landingpage'
    | '/_layout/settings/mimetypes'
    | '/_layout/settings/navigation'
    | '/_layout/settings/priocategories'
    | '/_layout/settings/ratecharts'
    | '/_layout/settings/subscriptions'
    | '/_layout/forms/'
    | '/_layout/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  DatenschutzRoute: typeof DatenschutzRoute
  ImpressumRoute: typeof ImpressumRoute
  LoginRoute: typeof LoginRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/usersettings': {
      id: '/_layout/usersettings'
      path: '/usersettings'
      fullPath: '/usersettings'
      preLoaderRoute: typeof LayoutUsersettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/users': {
      id: '/_layout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof LayoutUsersRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/tags': {
      id: '/_layout/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof LayoutTagsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/roles': {
      id: '/_layout/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof LayoutRolesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/publications': {
      id: '/_layout/publications'
      path: '/publications'
      fullPath: '/publications'
      preLoaderRoute: typeof LayoutPublicationsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/permissions': {
      id: '/_layout/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof LayoutPermissionsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/media': {
      id: '/_layout/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof LayoutMediaRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/categories': {
      id: '/_layout/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof LayoutCategoriesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/authors': {
      id: '/_layout/authors'
      path: '/authors'
      fullPath: '/authors'
      preLoaderRoute: typeof LayoutAuthorsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/authorgroups': {
      id: '/_layout/authorgroups'
      path: '/authorgroups'
      fullPath: '/authorgroups'
      preLoaderRoute: typeof LayoutAuthorgroupsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/ads': {
      id: '/_layout/ads'
      path: '/ads'
      fullPath: '/ads'
      preLoaderRoute: typeof LayoutAdsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/': {
      id: '/_layout/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/forms/': {
      id: '/_layout/forms/'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof LayoutFormsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/subscriptions': {
      id: '/_layout/settings/subscriptions'
      path: '/settings/subscriptions'
      fullPath: '/settings/subscriptions'
      preLoaderRoute: typeof LayoutSettingsSubscriptionsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/ratecharts': {
      id: '/_layout/settings/ratecharts'
      path: '/settings/ratecharts'
      fullPath: '/settings/ratecharts'
      preLoaderRoute: typeof LayoutSettingsRatechartsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/priocategories': {
      id: '/_layout/settings/priocategories'
      path: '/settings/priocategories'
      fullPath: '/settings/priocategories'
      preLoaderRoute: typeof LayoutSettingsPriocategoriesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/navigation': {
      id: '/_layout/settings/navigation'
      path: '/settings/navigation'
      fullPath: '/settings/navigation'
      preLoaderRoute: typeof LayoutSettingsNavigationRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/mimetypes': {
      id: '/_layout/settings/mimetypes'
      path: '/settings/mimetypes'
      fullPath: '/settings/mimetypes'
      preLoaderRoute: typeof LayoutSettingsMimetypesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/landingpage': {
      id: '/_layout/settings/landingpage'
      path: '/settings/landingpage'
      fullPath: '/settings/landingpage'
      preLoaderRoute: typeof LayoutSettingsLandingpageRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings/actions': {
      id: '/_layout/settings/actions'
      path: '/settings/actions'
      fullPath: '/settings/actions'
      preLoaderRoute: typeof LayoutSettingsActionsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/forms/subscriptions': {
      id: '/_layout/forms/subscriptions'
      path: '/forms/subscriptions'
      fullPath: '/forms/subscriptions'
      preLoaderRoute: typeof LayoutFormsSubscriptionsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/forms/newsletters': {
      id: '/_layout/forms/newsletters'
      path: '/forms/newsletters'
      fullPath: '/forms/newsletters'
      preLoaderRoute: typeof LayoutFormsNewslettersRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutAdsRoute: typeof LayoutAdsRoute
  LayoutAuthorgroupsRoute: typeof LayoutAuthorgroupsRoute
  LayoutAuthorsRoute: typeof LayoutAuthorsRoute
  LayoutCategoriesRoute: typeof LayoutCategoriesRoute
  LayoutMediaRoute: typeof LayoutMediaRoute
  LayoutPermissionsRoute: typeof LayoutPermissionsRoute
  LayoutPublicationsRoute: typeof LayoutPublicationsRoute
  LayoutRolesRoute: typeof LayoutRolesRoute
  LayoutTagsRoute: typeof LayoutTagsRoute
  LayoutUsersRoute: typeof LayoutUsersRoute
  LayoutUsersettingsRoute: typeof LayoutUsersettingsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutFormsNewslettersRoute: typeof LayoutFormsNewslettersRoute
  LayoutFormsSubscriptionsRoute: typeof LayoutFormsSubscriptionsRoute
  LayoutSettingsActionsRoute: typeof LayoutSettingsActionsRoute
  LayoutSettingsLandingpageRoute: typeof LayoutSettingsLandingpageRoute
  LayoutSettingsMimetypesRoute: typeof LayoutSettingsMimetypesRoute
  LayoutSettingsNavigationRoute: typeof LayoutSettingsNavigationRoute
  LayoutSettingsPriocategoriesRoute: typeof LayoutSettingsPriocategoriesRoute
  LayoutSettingsRatechartsRoute: typeof LayoutSettingsRatechartsRoute
  LayoutSettingsSubscriptionsRoute: typeof LayoutSettingsSubscriptionsRoute
  LayoutFormsIndexRoute: typeof LayoutFormsIndexRoute
  LayoutSettingsIndexRoute: typeof LayoutSettingsIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAdsRoute: LayoutAdsRoute,
  LayoutAuthorgroupsRoute: LayoutAuthorgroupsRoute,
  LayoutAuthorsRoute: LayoutAuthorsRoute,
  LayoutCategoriesRoute: LayoutCategoriesRoute,
  LayoutMediaRoute: LayoutMediaRoute,
  LayoutPermissionsRoute: LayoutPermissionsRoute,
  LayoutPublicationsRoute: LayoutPublicationsRoute,
  LayoutRolesRoute: LayoutRolesRoute,
  LayoutTagsRoute: LayoutTagsRoute,
  LayoutUsersRoute: LayoutUsersRoute,
  LayoutUsersettingsRoute: LayoutUsersettingsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutFormsNewslettersRoute: LayoutFormsNewslettersRoute,
  LayoutFormsSubscriptionsRoute: LayoutFormsSubscriptionsRoute,
  LayoutSettingsActionsRoute: LayoutSettingsActionsRoute,
  LayoutSettingsLandingpageRoute: LayoutSettingsLandingpageRoute,
  LayoutSettingsMimetypesRoute: LayoutSettingsMimetypesRoute,
  LayoutSettingsNavigationRoute: LayoutSettingsNavigationRoute,
  LayoutSettingsPriocategoriesRoute: LayoutSettingsPriocategoriesRoute,
  LayoutSettingsRatechartsRoute: LayoutSettingsRatechartsRoute,
  LayoutSettingsSubscriptionsRoute: LayoutSettingsSubscriptionsRoute,
  LayoutFormsIndexRoute: LayoutFormsIndexRoute,
  LayoutSettingsIndexRoute: LayoutSettingsIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  DatenschutzRoute: DatenschutzRoute,
  ImpressumRoute: ImpressumRoute,
  LoginRoute: LoginRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
